import { useState, useEffect } from "react";
import { ListLayout } from "../../../layouts";
import { DataGrid } from "../../../components";
import { history, VeiculosService, notification } from "../../../services";
import { responseErros, formatPlacaVeiculo } from "../../../utils";
import { FormFiltroAvancado } from "./components";
import { PermisoesHelper } from "../../../helpers";

const ListVeiculosView = () => {
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("veiculos-visualizar");
  const [loading, setLoading] = useState(false);
  const [rowCount, setRowCount] = useState(null);
  const veiculosService = new VeiculosService();

  const [veiculos, setVeiculos] = useState([]);
  const colunas = [
    {
      field: "placa",
      headerName: "Placa",
      flex: 500,
      filtrar: true,
      valueFormatter: (params) => formatPlacaVeiculo(params.value),
    },
    {
      field: "renavam",
      headerName: "Renavam",
      flex: 500,
    },
  ];

  useEffect(() => {
    buscarVeiculos();
  }, []);

  const buscarVeiculos = async function (filter) {
    setLoading(true);
    const result = await veiculosService.getAll(filter);
    if (!result.isAxiosError) {
      setRowCount(result.data.count);
      setVeiculos(result.data.rows);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const onClickCadastrarVeiculo = function () {
    history.push("/faturamento/veiculos/create");
  };

  const onClickEditVeiculo = function (id) {
    history.push(`/faturamento/veiculos/${id}`);
  };

  const onClickDeleteVeiculo = async function (id) {
    const data = veiculos.find((item) => item.id === id);
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir ${data.placa}`
    );
    if (retornoAlerta.isConfirmed) {
      setLoading(true);
      const result = await veiculosService.deletar(id);
      if (!result.isAxiosError) {
        buscarVeiculos();
        notification.deletadoSucesso();
      } else {
        setLoading(false);
        responseErros(result);
      }
    }
  };

  const buscarPesquisaAvancada = async (filter) => {
    const filtrosAvancadosTemp = {
      ...filter,
    };
    const result = await veiculosService.getAllFiltroAvancado({
      ...filtrosAvancadosTemp,
      restritiva: true,
    });
    if (!result.isAxiosError) {
      setVeiculos(result.data.rows);
    } else {
      responseErros(result);
    }
  };

  const sendServerDatagrid = (props) => {
    if (props.tipoFiltro == "simples") {
      buscarVeiculos(props.filtros);
    } else {
      buscarPesquisaAvancada(props.filtros);
    }
  };

  return (
    <ListLayout
      title="Veículos"
      loading={loading}
      onClickCadastrar={onClickCadastrarVeiculo}
      permissaoButton={permissoesHelper.temPermisao("veiculos-cadastrar")}
    >
      <DataGrid
        rows={veiculos}
        columns={colunas}
        rowCount={rowCount}
        onClickEdit={onClickEditVeiculo}
        onClickDelete={onClickDeleteVeiculo}
        paginationMode={"server"}
        sendServer={(props) => sendServerDatagrid(props)}
        FormFiltroAvancado={FormFiltroAvancado}
        visualizarShow={permissoesHelper.temPermisao("veiculos-visualizar")}
        editShow={permissoesHelper.temPermisao("veiculos-editar")}
        deleteShow={permissoesHelper.temPermisao("veiculos-excluir")}
      />
    </ListLayout>
  );
};

export default ListVeiculosView;
